var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "drawer",
    {
      attrs: { "is-open": _vm.isDrawerOpen },
      on: { close: _vm.onCancel },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { class: _vm.actionsClassList },
                [
                  _vm.hasClearButton
                    ? _c(
                        "admin-link",
                        {
                          attrs: { theme: "light", "data-qa": "button:Clear" },
                          on: { click: _vm.onClear },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.Resources.Search
                                  .SearchProjectsFiltersSearchClearButton
                              ) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "_flex _ai-c" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "gfu-link _tc--light",
                          attrs: { type: "button", "data-qa": "button:Cancel" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.onCancel.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.Resources.Profile
                                  .UserFollowSettingsCancelButton
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "base-button",
                        {
                          staticClass: "_ml-3",
                          attrs: {
                            theme: "accent",
                            width: "compact",
                            enabled: _vm.canFilter,
                            "data-qa": "button:Search",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.onSearch.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.Resources.Search
                                  .SearchProjectsFiltersSearchApplyButton
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "_pt-3 _pb-3 _px-3" },
        [
          _c("h2", { staticClass: "gfu-hd gfu-hd--h1 _mb-3" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _vm._l(_vm.visibleFields, function (field) {
            return _c(
              "div",
              { key: field.modelName, staticClass: "_mb-3" },
              [
                _c(
                  _vm.resolveComponent(field.type),
                  _vm._b(
                    {
                      tag: "component",
                      attrs: {
                        name: `model.${field.modelName}`,
                        "data-qa": `filter:${field.qa}`,
                      },
                      on: {
                        input: (val) =>
                          field.onInput && field.onInput(val, _vm.model),
                      },
                      model: {
                        value: _vm.model[field.modelName],
                        callback: function ($$v) {
                          _vm.$set(_vm.model, field.modelName, $$v)
                        },
                        expression: "model[field.modelName]",
                      },
                    },
                    "component",
                    _vm.getComponentProps(field),
                    false
                  )
                ),
                _vm._v(" "),
                field.renderTags && _vm.getTagsForField(field).length
                  ? _c(
                      "div",
                      { staticClass: "_flexwrap _mt-2" },
                      _vm._l(_vm.getTagsForField(field), function (tag) {
                        return _c(
                          "base-button",
                          {
                            key: tag.value,
                            staticClass: "_mr-1 _mb-1",
                            attrs: {
                              width: "compact",
                              theme: "searchSecondary",
                              "data-qa": `tag-tile:${tag.label}`,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onTagRemove(field, tag)
                              },
                            },
                          },
                          [
                            _c("strong", { staticClass: "_ttl" }, [
                              _vm._v(_vm._s(tag.label)),
                            ]),
                            _vm._v(" "),
                            _c("base-icon", {
                              staticClass: "_ml-1",
                              attrs: { name: "window-close" },
                            }),
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }